import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling, {
  type MutationError
} from '@/hooks/useMutationWithErrorsHandling'

import type { CurriculumForm } from '../hooks/useCurriculumForm'

const useAddCurriculum = (options?: {
  saveAsDraft?: boolean
  onSuccess?: ({
    response,
    variables
  }: {
    response: { id: string }
    variables: CurriculumForm
  }) => void
  onError?: ({
    errors,
    variables
  }: {
    errors: MutationError<CurriculumForm, unknown>
    variables: CurriculumForm
  }) => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: CurriculumForm) =>
      httpService.panel.panelCurriculumsCreate({
        name: data.name,
        aim: data.aim,
        education_level: data.educationLevel,
        baskets: data.baskets.map(basket => ({
          basket_type: basket.type,
          basket_courses: basket.courses.map(item => ({
            course: item.course,
            time_unit: item.timeUnit,
            semesters: item.semesters.map(semester => ({
              is_active: semester.isActive,
              hours: semester.hours
            }))
          }))
        })),
        save_as_draft: options?.saveAsDraft
      }),

    onSuccess: (response, variables) =>
      options?.onSuccess?.({ response, variables }),
    onError: (errors, variables) => {
      options?.onError?.({ errors, variables })
    }
  })

export default useAddCurriculum
